import { useEnv } from '@src/contexts/env-context';
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface Props {
  pageTitle: string;
  pageDescription?: string;
}

const Meta = ({ pageTitle, pageDescription = '' }: Props) => {
  const { IS_PROD } = useEnv();
  return (
    <Helmet>
      <html className="ss-bg-page-background" />
      <title>Global SEND</title>
      {/* <title>{pageTitle} - Sprint</title>
      <meta name="description" content={pageDescription} /> */}
    </Helmet>
  );
};

export default Meta;
